import { SelectedJobInfoComponent } from './selected-job-info/selected-job-info.component';
import { PostJobIntroComponent } from './post-job-intro/post-job-intro.component';
import { CustomMaterialModule } from '../../core/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared-module/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MomentModule } from 'ngx-moment';
import { EditJobTplNavComponent } from './edit-job-tpl-nav/edit-job-tpl-nav.component';
import { JobInfoSalaryCardComponent } from './job-info-salary-card/job-info-salary-card.component';
import { JobInfoLocationCardComponent } from './job-info-location-card/job-info-location-card.component';
import { JobInfoDueDateCardComponent } from './job-info-due-date-card/job-info-due-date-card.component';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { JobInfoTeamCardComponent } from './job-info-team-card/job-info-team-card.component';
import { EnabledTeamOwnerFilterPipe } from './job-info-team-card/job-info-team-card.pipe';

export const COMPONENTS = [
  PostJobIntroComponent,
  SelectedJobInfoComponent,
  EditJobTplNavComponent,
  JobInfoSalaryCardComponent,
  JobInfoLocationCardComponent,
  JobInfoDueDateCardComponent,
  JobInfoTeamCardComponent,
  EnabledTeamOwnerFilterPipe,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    SharedModule,
    TranslateModule,
    CustomMaterialModule,
    MomentModule,
    LeafletModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [],
  entryComponents: [],
})
export class ComponentsModule {}
